module.exports = __webpack_public_path__ + "img/28.d14d8b67.png";